import React from 'react';

/**
 * Inline SVG flags — zero external dependencies, work on every browser, OS,
 * and network (including those that block CDN domains). Each flag is a minimal,
 * geometrically-accurate SVG sized 24x16 (3:2 ratio).
 */
const FLAGS = {
  // United Kingdom
  gb: (
    <svg viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg">
      <clipPath id="gb-c"><path d="M0 0h60v40H0z" /></clipPath>
      <g clipPath="url(#gb-c)">
        <path fill="#012169" d="M0 0h60v40H0z" />
        <path stroke="#fff" strokeWidth="6" d="M0 0l60 40m0-40L0 40" />
        <path stroke="#C8102E" strokeWidth="4" d="M0 0l60 40m0-40L0 40" />
        <path stroke="#fff" strokeWidth="10" d="M30 0v40M0 20h60" />
        <path stroke="#C8102E" strokeWidth="6" d="M30 0v40M0 20h60" />
      </g>
    </svg>
  ),
  // Germany
  de: (
    <svg viewBox="0 0 5 3" xmlns="http://www.w3.org/2000/svg">
      <path fill="#000" d="M0 0h5v1H0z" />
      <path fill="#D00" d="M0 1h5v1H0z" />
      <path fill="#FFCE00" d="M0 2h5v1H0z" />
    </svg>
  ),
  // Ukraine
  ua: (
    <svg viewBox="0 0 3 2" xmlns="http://www.w3.org/2000/svg">
      <path fill="#005BBB" d="M0 0h3v1H0z" />
      <path fill="#FFD500" d="M0 1h3v1H0z" />
    </svg>
  ),
  // Spain
  es: (
    <svg viewBox="0 0 3 2" xmlns="http://www.w3.org/2000/svg">
      <path fill="#C60B1E" d="M0 0h3v2H0z" />
      <path fill="#FFC400" d="M0 .5h3v1H0z" />
    </svg>
  ),
  // Russia
  ru: (
    <svg viewBox="0 0 9 6" xmlns="http://www.w3.org/2000/svg">
      <path fill="#fff" d="M0 0h9v2H0z" />
      <path fill="#0039A6" d="M0 2h9v2H0z" />
      <path fill="#D52B1E" d="M0 4h9v2H0z" />
    </svg>
  ),
  // China
  cn: (
    <svg viewBox="0 0 30 20" xmlns="http://www.w3.org/2000/svg">
      <path fill="#DE2910" d="M0 0h30v20H0z" />
      <g fill="#FFDE00">
        <path d="M6 3l1.18 3.64h3.82L7.91 8.91l1.18 3.64L6 10.29l-3.09 2.26 1.18-3.64L1 6.64h3.82z" />
        <path d="M12.4 1.6l.4 1.2h1.2l-1 .8.4 1.2-1-.8-1 .8.4-1.2-1-.8h1.2z" />
        <path d="M14.4 4l.4 1.2h1.2l-1 .8.4 1.2-1-.8-1 .8.4-1.2-1-.8h1.2z" />
        <path d="M14.4 7.2l.4 1.2h1.2l-1 .8.4 1.2-1-.8-1 .8.4-1.2-1-.8h1.2z" />
        <path d="M12.4 9.6l.4 1.2h1.2l-1 .8.4 1.2-1-.8-1 .8.4-1.2-1-.8h1.2z" />
      </g>
    </svg>
  ),
};

const COUNTRY_BY_LANG = {
  en: 'gb', de: 'de', uk: 'ua', es: 'es', ru: 'ru', zh: 'cn',
};

const Flag = ({ code = 'en', size = 16, className = '', alt }) => {
  const cc = COUNTRY_BY_LANG[code] || code;
  const svg = FLAGS[cc];
  if (!svg) {
    return (
      <span
        className={`inline-block rounded-[2px] bg-white/10 text-[8px] font-bold text-center shrink-0 ${className}`}
        style={{ width: size, height: Math.round(size * 0.66), lineHeight: `${Math.round(size * 0.66)}px` }}
      >
        {cc.toUpperCase()}
      </span>
    );
  }
  return (
    <span
      className={`inline-block overflow-hidden rounded-[2px] shrink-0 ${className}`}
      style={{ width: size, height: Math.round(size * 0.66), lineHeight: 0 }}
      role="img"
      aria-label={alt || cc.toUpperCase()}
      data-testid={`flag-${code}`}
    >
      {React.cloneElement(svg, {
        width: '100%',
        height: '100%',
        preserveAspectRatio: 'xMidYMid slice',
        style: { display: 'block' },
      })}
    </span>
  );
};

export default Flag;
